import exportFromJSON from "export-from-json";
import * as XLSX from "xlsx-js-style";
import { toast } from "react-toastify";

const liveUrl = process.env.REACT_APP_LIVE_URL;

export const viewSizeCalculator = (value, isPixel = false) => {
  const windowSize = window.innerWidth / window.innerHeight < 2.5;

  let calculatedValue;

  if (windowSize) {
    calculatedValue = isPixel
      ? (value / 1660) * 100
      : ((value * 16) / 1660) * 100;
  } else {
    calculatedValue = isPixel
      ? (value / 1660) * 100 * 0.78
      : ((value * 16) / 1660) * 100 * 0.78;
  }

  // return `${calculatedValue}vw`;
  return `${calculatedValue?.toFixed(2)}vw` || 0; // Ensuring two decimal places

  // return addUnit ? `${calculatedValue}vw` : calculatedValue;
};

/**
 * Numeric (px) counterpart of viewSizeCalculator. Recharts numeric props
 * (margins, padding, radii, strokeWidth) can't take vw strings, so we mirror
 * the same 1660px design-width math and return a pixel value that tracks the
 * current viewport. This keeps charts visually identical across resolutions
 * and browser zoom levels.
 */
export const scalePx = (value, isPixel = false) => {
  const factor = window.innerWidth / window.innerHeight < 2.5 ? 1 : 0.78;
  const vwPercent = isPixel
    ? (value / 1660) * 100
    : ((value * 16) / 1660) * 100;
  return (vwPercent / 100) * window.innerWidth * factor;
};

/**accept in form of String to format the number in Million or Billion*/
export const formatNumber = (input) => {
  if (!input || input === "0" || input === "0.0" || input === "NaN" || input === "null") return "-";

  let str = input.toString().trim();

  // If input already contains B or M, return as-is (with $ sign if missing)
  if (/[MB]$/i.test(str)) {
    return str.startsWith("$") ? str : `$${str}`;
  }

  // Remove $ and commas
  let num = parseFloat(str.replace(/[$,]/g, ""));
  if (isNaN(num) || num === 0) return "-";

  const sign = num < 0 ? "-" : "";
  const absNum = Math.abs(num);

  if (absNum >= 1e9) {
    return `$${sign}${(absNum / 1e9).toFixed(2)}B`;
  } else if (absNum >= 1e6) {
    return `$${sign}${(absNum / 1e6).toFixed(2)}M`;
  } else {
    return `$${sign}${absNum.toLocaleString()}`;
  }
};

export const formatFloorValue = (num) => {
  return Math.floor(num).toLocaleString();
};

export const isValidUSZipCode = (sZip) => {
  return /^(\d{4}|\d{5}(-\d{4})?)$/.test(sZip);
};

export const bookmarkSuccessToast = (message) => {
  const msg = message ?? "Hospital added to bookmark successfully!";
  toast.success(msg, {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    // style: { background: "white", color: "#E35B42" },
    style: { fontSize: "14px" },
  });
};

export const InfoToast = (message) => {
  const msg = message ?? "Info!";
  toast.info(msg, {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    // style: { background: "white", color: "#E35B42" },
    style: { fontSize: "14px" },
  });
};

export const bookmarkErrorToast = (errMessage) => {
  toast.error(errMessage, {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    style: { fontSize: "12px" },
  });
};

export const formatLocation = (location, isStateFirst = false) => {
  if (!location) return "";
  const [city, state] = location.split(", ");

  const formatCity = (city) =>
    city
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

  const formattedCity = formatCity(city);
  const formattedState = state.toUpperCase();

  return isStateFirst
    ? `${formattedState}, ${formattedCity}`
    : `${formattedCity}, ${formattedState}`;
};

export function formatPhoneNumber(phone) {
  if (phone == null) return "";

  const cleaned = String(phone).replace(/\D/g, "");

  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }

  return phone;
}

export const toTitleCase = (str) => {
  if (!str) return "";
  return str
    .toLowerCase()
    .split(" ")
    .map((word) =>
      word
        .split("-")
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join("-"),
    )
    .join(" ");
};

export function countUrbanRural(dataArray) {
  let counts = {
    Urban: 0,
    Rural: 0,
    VoluntaryNonprofit: 0,
    Proprietary: 0,
    Government: 0,
    coc_type: 0,
    high_revenue: 0,
  };

  if (dataArray.length === 0) return counts;
  dataArray.forEach(({ Geography, "ownership type": ownershipType }) => {
    if (Geography in counts) {
      counts[Geography]++;
    }

    if (ownershipType?.includes("Voluntary Nonprofit")) {
      counts.VoluntaryNonprofit++;
    }
    if (ownershipType?.includes("Proprietary")) {
      counts.Proprietary++;
    }
    if (ownershipType?.includes("Government")) {
      counts.Government++;
    }
  });
  return counts;
}
export const FILTER_CONFIG = [
  {
    id: "proprietary",
    title: "For Profit",
    type: "ownership_type",
    default: true,
    count: 0,
  },
  {
    id: "voluntary_nonprofit",
    title: "Vol. Non Profit",
    type: "ownership_type",
    default: true,
    count: 0,
  },
  {
    id: "government",
    title: "Government",
    type: "ownership_type",
    default: true,
    count: 0,
  },
  {
    id: "urban",
    title: "Urban",
    type: "geography",
    default: true,

    count: 0,
  },
  {
    id: "rural",
    title: "Rural",
    type: "geography",
    default: true,

    count: 0,
  },
  // {
  //   id: "coc_type",
  //   title: "CoC Accredited",
  //   type: "coc_type",
  //   default: false,
  //   condition: (item) => item.accreditations?.toLowerCase() === "coc",
  // },
  {
    id: "high_revenue",
    title: "High Rev. ( >$50M )",
    type: "gross_revenue",
    default: true,

    count: 0,
  },
];
export const countQuickFilters = (data) => {
  if (!data || !Array.isArray(data)) return [];
  return FILTER_CONFIG.map((filter) => ({
    id: filter.id,
    title: filter.title,
    type: filter.type,
    default: filter.default,
    count:
      !data || !Array.isArray(data) ? 0 : data.filter(filter.condition).length,
  }));
};

export const transformHospitalData = (apiData, startIndex = 0) => {
  return apiData.map((item, index) => ({
    "Sr.": startIndex + index + 1,
    Geography: item.urban_rural_flag || "N/A",
    "hospital name": item.hosp10_name || "N/A",
    location: item.location || "N/A",
    county: item.county !== null ? item.county : "N/A",
    "ownership type":
      item.prov_control_type !== null ? item.prov_control_type : "N/A",
    "no. of beds.":
      item.calc_stats_beds_total !== null &&
      Number(item.calc_stats_beds_total) !== 0
        ? item.calc_stats_beds_total
        : "N/A",
    "patient discharges":
      item.calc_stats_adj_pt_discharge !== null &&
      Number(item.calc_stats_adj_pt_discharge) !== 0
        ? item.calc_stats_adj_pt_discharge
        : "N/A",
    "net patient revenue":
      item.net_patient_revenue !== null &&
      Number(item.net_patient_revenue) !== 0
        ? item.net_patient_revenue
        : "N/A",
    accreditations: item?.accreditation_count || "N/A",
    "cms rating": item?.hcahps
      ? `${item.hcahps}☆`
      : "N/A",
    provider_number: item?.provider_number,
  }));
};

/**format the data accorind to the table columns */
export const formatHospitalDetails = (data, startIndex = 0) => {
  const formattedData = data?.map((item, index) => {
    // Format patient discharge
    const dischargeFormatted = (() => {
      const value = item.calc_stats_adj_pt_discharge;
      if (!value || value === 0 || value === "0" || value === "0.0") return "N/A";
      const num = Number(value);
      if (isNaN(num) || num === 0) return "N/A";
      const rounded = Math.round(num);
      return rounded.toLocaleString ? rounded.toLocaleString() : rounded.toString();
    })();
    
    return {
      "Sr.": startIndex + index + 1,
      Geography: item.urban_rural_flag || "N/A",
      "hospital name": item.hosp10_name !== null ? item.hosp10_name : "N/A",
      location: item.city && item.state ? `${item.city}, ${item.state}` : "N/A",
      county: item.county !== null ? item.county : "N/A",
      "ownership type":
        item.prov_control_type !== null ? item.prov_control_type : "N/A",
      "no. of beds.":
        item.calc_stats_beds_total !== null &&
        Number(item.calc_stats_beds_total) !== 0 &&
        !isNaN(Number(item.calc_stats_beds_total))
          ? item.calc_stats_beds_total
          : "N/A",
      "patient discharges": dischargeFormatted,
      "net patient revenue": 
        item.net_patient_revenue !== null && 
        !isNaN(Number(item.net_patient_revenue)) && 
        Number(item.net_patient_revenue) !== 0
          ? formatNumber(item.net_patient_revenue.toString())
          : "N/A",
      accreditations: item.accreditations || "N/A", // Fixed: use accreditations instead of accreditation_count
      website: item.website || "N/A",
      "cms rating": item?.overall_rating && item.overall_rating !== "None" && item.overall_rating !== null
        ? `${item.overall_rating.toFixed(1)}☆`
        : "N/A",
      "overall rating": item?.overall_rating !== null && item?.overall_rating !== undefined && item.overall_rating !== "None"
        ? item.overall_rating
        : "N/A",
      provider_number: item.provider_number,
      esa: item.esa,
      // Add rankings and scores from API response
      ranking: item.ranking || "N/A",
      score: item.score || "N/A"
    };
  });

  return formattedData;
};

export const formatLatLng = (lat, lng) => {
  const latDirection = lat >= 0 ? "N" : "S";
  const lngDirection = lng >= 0 ? "E" : "W";

  return `${Math.abs(lat).toFixed(4)}° ${latDirection}, ${Math.abs(lng).toFixed(4)}° ${lngDirection}`;
};

export const formatNumberTo = (n) => {
  if (n >= 1_000_000_000) {
    return (n / 1_000_000_000).toFixed(2) + "B";
  } else if (n >= 1_000_000) {
    return (n / 1_000_000).toFixed(2) + "M";
  } else if (n >= 1_000) {
    return (n / 1_000).toFixed(2) + "K";
  } else {
    return n.toString();
  }
};

export const formatNumberToWithoutDecimal = (n) => {
  if (n >= 1_000_000_000) {
    return Math.round(n / 1_000_000_000) + "B";
  } else if (n >= 1_000_000) {
    return Math.round(n / 1_000_000) + "M";
  } else if (n >= 1_000) {
    return Math.round(n / 1_000) + "K";
  } else {
    return n.toString();
  }
};

export const exportTableData = (dataArray, type, fileName = "TableData") => {

  const formattedData = dataArray.map((item) => ({
    "Hospital Name": item["hospital name"] ?? "-",
    Location: `${item.location ?? "-"}, ${item.county ?? "-"}`,
    Website: item.website ?? "-",
    Geography: item.Geography ?? "-",
    "Ownership Type": item["ownership type"] ?? "-",
    "Number of Beds": item["no. of beds."] ?? "-",
  
    "Patient Discharges":
      item["patient discharges"] != null && item["patient discharges"].toString().trim() !== ""
        ? Number(item["patient discharges"].toString().trim().replace(/[^0-9.-]/g, "")).toFixed(0)
        : "-",
  
    "Net Patient Revenue": item["net patient revenue"]
      ? formatNumber(item["net patient revenue"].toString().trim())
      : "-",
  
    Accreditations: item["accreditations"] ?? "-",
    // "CMS Rating": item["cms rating"]
    //   ? item["cms rating"].replace(/[^0-9.]/g, "")
    //   : "-",
    "Provider Number": item.provider_number ?? "-",
    "Overall Rating" :item["overall rating"] ?? "N/A",
  }));
  if (type === "xlsx") {
    const worksheet = XLSX.utils.json_to_sheet(formattedData);

    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    for (let col = range.s.c; col <= range.e.c; col++) {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: col });
      if (worksheet[cellRef]) {
        worksheet[cellRef].s = {
          font: { bold: true },
        };
      }
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Table Data");
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
    return;
  }

  const exportType = exportFromJSON.types[type];
  exportFromJSON({ data: formattedData, fileName, exportType });
};

export const formatTextToCapitalize = (name) => {
  return name
    ?.toLowerCase()
    .replace(
      /\b\w+/g,
      (word) => word.charAt(0).toUpperCase() + word.slice(1),
    );
};

export const formatBookmarkData = (rawData) => {
  const bookmarksList = rawData.map((ele) => ({
    name: formatTextToCapitalize(ele.hosp10_name),
    address: formatTextToCapitalize(`${ele.state}, ${ele.city}`),
    link: `${liveUrl}/hospitals/${ele.provider_number}`,
    provider_number: ele.provider_number,
    esa: ele.esa,
  }));

  const options = rawData.map((ele, ind) => ({
    id: ind + 1,
    value: formatTextToCapitalize(ele.hosp10_name),
    label: formatTextToCapitalize(ele.hosp10_name),
    location: formatTextToCapitalize(`${ele.state}, ${ele.city}`),
    link: `${liveUrl}/hospitals/${ele.provider_number}`,
  }));

  options.unshift({
    value: `All Bookmarked Hospitals (${rawData.length})`,
    label: `All Bookmarked Hospitals (${rawData.length})`,
  });

  const hospitalDetailsArray = formatHospitalDetails(rawData);

  return { bookmarksList, options, hospitalDetailsArray };
};

export const extractProviderNumbers = (hospitalArray) => {
  if(!Array.isArray(hospitalArray) || hospitalArray.length === 0) return [];
  return hospitalArray
    .map((hospital) => hospital.provider_number)
    .filter((num) => num !== undefined && num !== null);
};

/**convert net_patient_revenue_min, net_patient_revenue_max to million by multiplying value by 1 million*/
export const convertToMillion = (data) => {
  const temp = { ...data };
  // Only convert real, numeric values. Empty/undefined/non-numeric inputs are
  // left untouched so we never emit NaN into the API query.
  const toMillion = (value) => {
    if (value === "" || value === null || value === undefined) return value;
    const num = Number(value);
    return Number.isNaN(num) ? value : num * 1000000;
  };
  temp.net_patient_revenue_min = toMillion(temp.net_patient_revenue_min);
  temp.net_patient_revenue_max = toMillion(temp.net_patient_revenue_max);
  return temp;
};

// Color Gradient for Ranking
export const getRankColor = (rank, totalHospitals) => {
  if (
    !rank || rank === "N/A" || !totalHospitals || totalHospitals <= 0) {
    return { backgroundColor: "transparent", color: "#333333" };
  }
  if (totalHospitals === 1) {
    return {
      backgroundColor: "#4e9e6a",
      color: "white",
  };
}

  const numericRank =
    typeof rank === "string" ? parseFloat(rank) : rank;

  if (isNaN(numericRank)) {
    return { backgroundColor: "transparent", color: "#333333" };
  }

  // Convert rank to percentage
  // Rank 1 = 100%
  // Last Rank = 0%
  const percentage = Math.max(0,Math.min(
    ((totalHospitals - numericRank) /Math.max(totalHospitals - 1, 1)) *100,100)
  );
  // Discrete palette colors from low rank (red) to high rank (green).
  // Ranks are bucketed into these solid swatches instead of being
  // interpolated, which keeps the cell colors clean and eye-friendly.
  const paletteColors = [
    "#c34141", // red (low)
    "#c96d65", // salmon
    "#d9a07c", // orange-tan
    "#c8bf8d", // tan (mid)
    "#a7c286", // yellow-green
    "#85b97b", // light green
    "#68ab72", // green
    "#4e9e6a", // dark green (high)
  ];

  // Map the percentage into one of the discrete swatches
  const bucketIndex = Math.min(
    paletteColors.length - 1,
    Math.floor((percentage / 100) * paletteColors.length)
  );
  const backgroundColor = paletteColors[bucketIndex];

  // Choose readable text color based on swatch brightness
  const { r, g, b } = hexToRgb(backgroundColor);
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  const textColor = brightness > 150 ? "#333333" : "white";

  return { backgroundColor, color: textColor };
};

// Color Gradient for Ranking
// export const getScoreColor = (score, allScores) => {
//   if (!score || score === "N/A" || !allScores || allScores.length === 0) {
//     return { backgroundColor: "transparent", color: "#333333" };
//   }

//   const numericScore = typeof score === "string" ? parseFloat(score) : score;
//   if (isNaN(numericScore)) {
//     return { backgroundColor: "transparent", color: "#333333" };
//   }

//   // Convert to percentage scale (0-100)
//   const percentage = Math.max(0, Math.min(numericScore * 100, 100)); 

//   // Discrete palette colors from low score (red) to high score (green).
//   // Scores are bucketed into these solid swatches instead of being
//   // interpolated, which keeps the cell colors clean and eye-friendly.
//   const paletteColors = [
//     "#c34141", // red (low)
//     "#c96d65", // salmon
//     "#d9a07c", // orange-tan
//     "#c8bf8d", // tan (mid)
//     "#a7c286", // yellow-green
//     "#85b97b", // light green
//     "#68ab72", // green
//     "#4e9e6a"  // dark green (high)
//   ];

//   // Map the percentage into one of the discrete swatches
//   const bucketIndex = Math.min(
//     paletteColors.length - 1,
//     Math.floor((percentage / 100) * paletteColors.length)
//   );
//   const backgroundColor = paletteColors[bucketIndex];

//   // Choose readable text color based on swatch brightness
//   const { r, g, b } = hexToRgb(backgroundColor);
//   const brightness = (r * 299 + g * 587 + b * 114) / 1000;
//   const textColor = brightness > 150 ? "#333333" : "white";

//   return { backgroundColor, color: textColor };
// };

// Helpers
function hexToRgb(hex) {
  const clean = hex.replace("#", "");
  const bigint = parseInt(clean, 16);
  return {
    r: (bigint >> 16) & 255,
    g: (bigint >> 8) & 255,
    b: bigint & 255
  };
}